import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './PurchaseLoginRequireAlert.module.scss';

interface Props {
  labelType: string;
  onClick: () => void;
}

const PurchaseLoginRequireAlert = ({ labelType, onClick }: Props) => {
  const classes = classNames(css.PurchaseLoginRequireAlert);
  const intl = useIntl();

  return (
    <div className={classes}>
      <p className={css.PurchaseLoginRequireAlert__Paragraph}>
        {intl.formatMessage({
          id: `purchases.purchaseLoginRequireAlert.message1.${labelType}`,
        })}
      </p>
      <p className={css.PurchaseLoginRequireAlert__Paragraph}>
        <FormattedMessage
          id={'purchases.purchaseLoginRequireAlert.message2'}
          values={{
            createUser: (
              <a
                onClick={onClick}
                className={css.PurchaseLoginRequireAlert__Link}
              >
                {intl.formatMessage({
                  id: 'purchases.purchaseLoginRequireAlert.here',
                })}
              </a>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default PurchaseLoginRequireAlert;
